import { createBreakpoints } from '@solid-primitives/media'
import { clsx, type ClassValue } from 'clsx'
import DOMPurify from 'dompurify'
import { tailwindTheme } from '../tailwind/tailwind-theme'

export const toggleStringArrayItem = (arr: string[], item: string) =>
  arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item]

export function cx(...args: ClassValue[]) {
  return clsx(args)
}

const screens = {
  ...tailwindTheme.screens,
} as const

export const breakpoints = createBreakpoints(screens)

export const stripHtml = (content: string) => {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [],
  })
}

export const convertStringToStringArray = (string?: string) => {
  if (!string) return []
  return string.split(',')
}

export const logger = (value: unknown, type?: 'log' | 'error') => {
  // eslint-disable-next-line no-console
  if (type === 'error') console.error(value)
  // eslint-disable-next-line no-console
  else console.log(value)
}

export function getCurrentDate() {
  return new Intl.DateTimeFormat('en-CA', {
    // en-CA uses YYYY-MM-DD format
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date())
}

export function sanitizeFileName(input: string): string {
  // Replace spaces with underscores
  input = input.replace(/\s+/g, '_')

  // Remove all non-alphanumeric characters, dashes, and underscores
  return input.replace(/[^a-zA-Z0-9-_]/g, '')
}

export function decodeHtmlEntities(text: string): string {
  const textArea = document.createElement('textarea')
  textArea.innerHTML = text
  return textArea.value
}

export function generateMailtoShareUrl({
  to,
  subject,
  body,
}: {
  to?: string
  subject: string
  body: string
}): string {
  const encodedSubject = encodeURIComponent(subject)
  const encodedBody = encodeURIComponent(body)
  return `mailto:${to ? to : ' '}?subject=${encodedSubject}&body=${encodedBody}`
}

export function shortenString(
  str: string,
  maxLen: number,
  append?: string,
  separator: string = ' '
) {
  if (str.length <= maxLen) return str
  return str.substring(0, str.lastIndexOf(separator, maxLen)) + (append ? append : '')
}
export function removeHtmlTags(str: string): string {
  return str.replace(/<\/?[^>]+(>|$)/g, '')
}
export function decodeHtml(html: string) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  return doc.documentElement.textContent
}
